import CirclePlusFilled from '../../src/legacy/CirclePlusFilled.tsx';
export default CirclePlusFilled;
